
const prefix = 'liveStream-'

const isSupported = !!window.localStorage

export function get(key, time){

}

export function getGlobal(key, time){
  if(!isSupported) return
  const str = localStorage.getItem(key)
  if(!str) return
  let t, v, json
  try{
    json = JSON.parse(str)
    v = json.v
    t = json.t
  }catch(e){
    console.error(e)
    return
  }
  return v
}

export function set(key, value){

}

export function setGlobal(key, value){
  if(!isSupported) return
  try{
    localStorage.setItem(key, JSON.stringify({t: new Date().getTime(), v: value}))
  }catch(e){
    console.error(e)
    return
  }
}

export function remove(key){

}

export function removeGlobal(key){

}

export function clear(){

}





// WEBPACK FOOTER //
// ./src/common/storage.js